import React from 'react';
import PropTypes from 'prop-types';
import Button from 'tailwind-components/Button/Button';

export default function ContentLibraryPreviewPanel({
  selectedAsset,
  actionLabel,
  canAct,
  onAssetAction
}) {
  if (!selectedAsset) return null;

  return (
    <div data-tour='content-library-preview' className='flex h-full min-h-0 flex-col gap-3'>
      <p className='m-0 text-xs font-medium uppercase text-gray-500'>Preview</p>
      <div>
        <h3 className='m-0 text-lg font-semibold text-gray-900'>
          {selectedAsset.name || 'Untitled'}
        </h3>
        <p className='m-0 mt-1 text-sm text-gray-600'>
          {selectedAsset.type || '—'}
        </p>
      </div>
      <div>
        <p className='m-0 mb-1 text-xs font-medium text-gray-500'>
          Description
        </p>
        <p className='m-0 text-sm text-gray-600'>
          {selectedAsset.description || '—'}
        </p>
      </div>

      <div className='flex w-full min-h-0 min-w-0 flex-1 items-start justify-center overflow-hidden py-1'>
        {selectedAsset.previewImgUrl ? (
          <img
            src={selectedAsset.previewImgUrl}
            alt=''
            className='max-h-80 w-auto rounded-md shadow-xl sm:max-h-96'
          />
        ) : (
          <div className='flex min-h-48 w-full max-w-sm items-center justify-center rounded-md bg-gray-50 p-4 text-sm text-gray-400 shadow-md'>
            No preview image
          </div>
        )}
      </div>

      <div className='flex w-full justify-center pt-1'>
        <Button
          type='button'
          variant='primaryLight'
          size='medium'
          onClick={onAssetAction}
          isDisabled={!canAct}
          className='min-w-40 max-w-full'
          text={actionLabel}
        />
      </div>
    </div>
  );
}

ContentLibraryPreviewPanel.propTypes = {
  selectedAsset: PropTypes.object,
  actionLabel: PropTypes.string.isRequired,
  canAct: PropTypes.bool.isRequired,
  onAssetAction: PropTypes.func.isRequired
};

ContentLibraryPreviewPanel.defaultProps = {
  selectedAsset: null
};
